import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'
import VueAxios from 'vue-axios'
import { config } from '../config';


Vue.use(Vuex)
Vue.use(VueAxios, axios)


Vue.use(Vuex)




const getDefaultState = () => {



  return {
  
  // PJ Spezifisch

	//AktivesTertial:  '',- Nutzer - rotation,
	tertiale: [{name: "Allgemeinmedizin", id:0 , src: "assets/allgemeinmedizin.jpg", einleitung:"Die Ausbildung im PJ soll Studierende&nbsp;<strong>zunehmend bef&auml;higen, &auml;rztliche Aufgaben zu &uuml;bernehmen,</strong> damit Sie nach Abschluss ihres Medizinstudiums in der Lage sind,&nbsp;<strong>eigenst&auml;ndig und eigenverantwortlich Patienten zu versorgen</strong>. Dazu werden Studierende von erfahrenen &Auml;rzten und &Auml;rztinnen betreut und supervidiert. PJ-Studierende sollten schrittweise lernen, eigene Patienten zu &uuml;bernehmen und so die &auml;rztlichen Abl&auml;ufe in der Tiefe kennen lernen.<br>Das Konzept der&nbsp;<strong>Anvertraubaren Professionellen T&auml;tigkeiten (APT)</strong> versucht, die Schritte zur eigenst&auml;ndigen Patientenversorgung in nachvollziehbaren Schritten zu strukturieren.<br>Dazu wurden in einem nationalen Konsens durch die Fachgesellschaften DEGAM und GHA f&uuml;r das PJ zugeschnittene APT f&uuml;r das Wahltertial Allgemeinmedizin entwickelt. Die Struktur dieser APT sowie das unten geschilderte Vorgehen wurden in einer Arbeitsgruppe des MFT weiterentwickelt und mit den Curricula f&uuml;r die Tertiale Innere Medizin und Chirurgie abgeglichen.<br>Dieses Konzept beschreibt<strong>&nbsp;APT in der Allgemeinmedizin</strong>, definiert die Stufen, die festlegen, wieviel Eigenst&auml;ndigkeit den PJ-Studierenden in der Praxis anvertraut werden kann und bietet eine Anleitung, wie der Prozess des Anvertrauens durch einen Arzt oder eine &Auml;rztin vorgenommen und &uuml;berpr&uuml;ft werden kann. Die definierten Stufen der Supervision gelten jeweils f&uuml;r das Ende des Praktischen Jahres und entsprechen damit dem Absolventenniveau. <em>(Quelle: Medizinische Fakult&auml;tentag)</em>"},{name: "Anästhesiologie", id:1 , src: "assets/anaesthesie.jpg", einleitung:"<p>Die Ausbildung im PJ soll Studierende<strong> zunehmend bef&auml;higen, &auml;rztliche Aufgaben zu &uuml;bernehmen</strong>, damit sie nach Abschluss ihres Medizinstudiums in der Lage sind, e<strong>igenst&auml;ndig und eigenverantwortlich Patienten</strong> zu versorgen. Dazu werden Studierende von erfahrenen &Auml;rzten und &Auml;rztinnen betreut und angeleitet, wobei eine 1:1-Betreuung angestrebt wird.</p><p>PJ-Studierende sollten schrittweise lernen, eigene Patienten im perioperativen Kontext zu betreuuen und so die &auml;rztlichen Abl&auml;ufe in der Tiefe kennen lernen.</p><p>Das Konzept der <strong>Anvertraubaren Professionellen T&auml;tigkeiten (APT)</strong> versucht, die Schritte zur eigenst&auml;ndigen Patientenversorgung in nachvollziehbaren Schritten zu strukturieren.</p><p>Dieses Konzept beschreibt <strong>APT in der Anästhesiologie</strong>, definiert die Stufen, die festlegen, wieviel Eigenst&auml;ndigkeit den PJ-Studierenden im klinischen Alltag anvertraut werden kann und bietet eine Anleitung, wie der Prozess des Anvertrauens durch einen Arzt oder eine &Auml;rztin vorgenommen und &uuml;berpr&uuml;ft werden kann. Die definierten Stufen der Supervision gelten jeweils f&uuml;r das Ende des Praktischen Jahres und entsprechen damit dem Absolventenniveau.</p><em>(Quelle: Klinik für Anästhesiologie (UKE) Dr. med. Parisa Moll-Khosrawi und Dr. med. Leonie Schulte-Uentrop)</em>"},{name: "Chirurgie", id:2, src: "assets/chirurgie.jpg", einleitung:"<p>Die Ausbildung im PJ soll Studierende<strong> zunehmend bef&auml;higen, &auml;rztliche Aufgaben zu &uuml;bernehmen</strong>, damit sie nach Abschluss ihres Medizinstudiums in der Lage sind, e<strong>igenst&auml;ndig und eigenverantwortlich Patienten</strong> zu versorgen. Dazu werden Studierende von erfahrenen &Auml;rzten und &Auml;rztinnen betreut und angeleitet, wobei eine 1:1-Betreuung angestrebt wird.</p><p>PJ-Studierende sollten schrittweise lernen, eigene Patienten bzw. Patientenzimmer von der Aufnahme &uuml;ber die t&auml;gliche Visite bis zur Entlassung zu &uuml;bernehmen und so die &auml;rztlichen Abl&auml;ufe in der Tiefe kennen lernen.</p><p>Das Konzept der <strong>Anvertraubaren Professionellen T&auml;tigkeiten (APT)</strong> versucht, die Schritte zur eigenst&auml;ndigen Patientenversorgung in nachvollziehbaren Schritten zu strukturieren.</p><p>Dieses Konzept beschreibt <strong>APT in der Chirurgie</strong>, definiert die Stufen, die festlegen, wieviel Eigenst&auml;ndigkeit den PJ-Studierenden im klinischen Alltag anvertraut werden kann und bietet eine Anleitung, wie der Prozess des Anvertrauens durch einen Arzt oder eine &Auml;rztin vorgenommen und &uuml;berpr&uuml;ft werden kann. Die definierten Stufen der Supervision gelten jeweils f&uuml;r das Ende des Praktischen Jahres und entsprechen damit dem Absolventenniveau.</p><em>(Quelle: Medizinische Fakult&auml;tentag)</em>"},{name: "Innere Medizin", id:3 , src: "assets/innere.jpg", einleitung: "<p>Die Ausbildung im PJ soll Studierende<strong> zunehmend bef&auml;higen, &auml;rztliche Aufgaben zu &uuml;bernehmen</strong>, damit sie nach Abschluss ihres Medizinstudiums in der Lage sind, e<strong>igenst&auml;ndig und eigenverantwortlich Patienten</strong> zu versorgen. Dazu werden Studierende von erfahrenen &Auml;rzten und &Auml;rztinnen betreut und angeleitet, wobei eine 1:1-Betreuung angestrebt wird.</p><p>PJ-Studierende sollten schrittweise lernen, eigene Patienten bzw. Patientenzimmer von der Aufnahme &uuml;ber die t&auml;gliche Visite bis zur Entlassung zu &uuml;bernehmen und so die &auml;rztlichen Abl&auml;ufe in der Tiefe kennen lernen.</p><p>Das Konzept der <strong>Anvertraubaren Professionellen T&auml;tigkeiten (APT)</strong> versucht, die Schritte zur eigenst&auml;ndigen Patientenversorgung in nachvollziehbaren Schritten zu strukturieren.</p>Dieses Konzept beschreibt<b> APT in der Inneren Medizin</b>, definiert die Stufen, die festlegen, wieviel Eigenständigkeit den PJ-Studierenden im klinischen Alltag anvertraut werden kann und bietet eine Anleitung, wie der Prozess des Anvertrauens durch einen Arzt oder eine Ärztin vorgenommen und überprüft werden kann. Die definierten Stufen der Supervision gelten jeweils für das Ende des Praktischen Jahres und entsprechen damit dem Absolventenniveau</p><em>(Quelle: Medizinische Fakult&auml;tentag)</em>"},{name: "HNO", id:4 , src: "assets/hno.jpeg", einleitung:"Die Ausbildung im PJ soll Studierende&nbsp;<strong>zunehmend bef&auml;higen, &auml;rztliche Aufgaben zu &uuml;bernehmen,</strong> damit Sie nach Abschluss ihres Medizinstudiums in der Lage sind,&nbsp;<strong>eigenst&auml;ndig und eigenverantwortlich Patienten zu versorgen</strong>. Dazu werden Studierende von erfahrenen &Auml;rzten und &Auml;rztinnen betreut und supervidiert. PJ-Studierende sollten schrittweise lernen, eigene Patienten zu &uuml;bernehmen und so die &auml;rztlichen Abl&auml;ufe in der Tiefe kennen lernen.<br>Das Konzept der&nbsp;<strong>Anvertraubaren Professionellen T&auml;tigkeiten (APT)</strong> versucht, die Schritte zur eigenst&auml;ndigen Patientenversorgung in nachvollziehbaren Schritten zu strukturieren.<br>Dazu wurden in einem nationalen Konsens durch die Fachgesellschaften DEGAM und GHA f&uuml;r das PJ zugeschnittene APT f&uuml;r das Wahltertial Allgemeinmedizin entwickelt. Die Struktur dieser APT sowie das unten geschilderte Vorgehen wurden in einer Arbeitsgruppe des MFT weiterentwickelt und mit den Curricula f&uuml;r die Tertiale Innere Medizin und Chirurgie abgeglichen.<br>Dieses Konzept beschreibt<strong>&nbsp;APT in der Allgemeinmedizin</strong>, definiert die Stufen, die festlegen, wieviel Eigenst&auml;ndigkeit den PJ-Studierenden in der Praxis anvertraut werden kann und bietet eine Anleitung, wie der Prozess des Anvertrauens durch einen Arzt oder eine &Auml;rztin vorgenommen und &uuml;berpr&uuml;ft werden kann. Die definierten Stufen der Supervision gelten jeweils f&uuml;r das Ende des Praktischen Jahres und entsprechen damit dem Absolventenniveau. <em>(Quelle: Medizinische Fakult&auml;tentag)</em>"}],
	APTs: [],
	GKs: [],
	GKInhalte: [],
	HKs : [],
	HKInhalte : [],
	ZeigeAPTmitID: null,
     
  
	//vars
	aktiveHK: null,
	aktiveGK: null,
	//aktiveAPT : null,
	
	filterwbjahr: true,
	overlayGKAddEditVisible : false,
	overlayHKAddEditVisible : false,
	editGK : {id : '', bezeichnung : ''},
	editHK : {id : '', bezeichnung : ''},
	overlayInhalteGKAddEditVisible: false,
	overlayInhalteHKAddEditVisible: false,
	overlayEditUserDetailsVisible: false,
	overlayAPTEditVisible: false,
	editAPT: null,
	overlayEditPasswordVisible: false,
	editUser: null,
	editInhalteGK: {id: '', frage: ''},
	editInhalteHK: {id: '', frage: ''},
	searchString : '',
	dopslidervalues: [],
	kppvalues: [],
	
	

	//User
	authenfiziert: false,
	aktiverNutzer: {},
	breadcrumbItems : [],
	vomNutzerimLogbuchGespeichertePruefungen: [],
	ausbilderUnterschrift: '',
	popoverausbilderUnterschrift: false,
	adminList: [],
	
	UnterschriftPendantListe: [],
	AusstehendeUnterschriftenPruefungen: [],
	AusstehendeUnterschriftenGespraeche: [],
	
	
	
	vonAnwaerterinnenimLogbuchGespeichertePruefungen: [],
	

	
	//uploadedImage
	pathNewUploadedImage : '',
	
	
	//Gespräche
	gespraeche: [{id:0 ,titel: "Einführungsgespräch", untertitel: "Was bringt der /die PJ-Studierende mit? Was erwartet er/sie?", inhalt: "Zu <b>Beginn</b> des (Halb)tertials bespricht der/die PJ–Koordinator/in die APT(Inhalt, Zielstufe und insbesondere die definierten punktuellen Beobachtungsoptionen). Im Gespräch nimmt der/die Studierende zu jeder APT eine differenzierte <b>Selbsteinschätzung</b> bezüglich des medizinischen Wissens, der klinischen Fertigkeiten und der professionellen Haltung vor.<br><br> Neben dieser Selbsteinschätzung und den Erwartungen sollen auch persönliche Ziele für den kommenden Ausbildungsabschnitt besprochen werden.<br><br> Aufgrund der Angaben und ggf. der dokumentierten Ergebnisse der vorherigen Tertiale wird für jede APT von einem Arzt oder einer Ärztin die Stufe des Anvertrauens festgelegt."},{id:1 ,titel: "Ausbildungsgespräche 1-3 „Work in progress“", untertitel: "Wie läuft´s? Was hat der/die PJ-Studierende erreicht? Was fehlt?", inhalt:"Nach 4 (ggf. 8 und 12 Wochen) des jeweiligen PJ-Tertials erfolgt ein <b>Verlaufsgespräch</b>. Neben einer erneuten Selbsteinschätzung zum Lernfortschritt können bei Bedarf Probleme und Ausbildungsdefizite angesprochen werden. Der/die PJ-Betreuer/in gibt ein strukturiertes Feedback zur persönlichen Entwicklung (Stärken, Verbesserungspotential, Ausblick) des/der PJ-Studierenden.<br>Mit folgenden Fragen sollte der/die PJ Studierende sich auf das Gesprächvorbereiten:<br><br><ul><li>Was waren meine Stärken im bisherigen Verlauf des Tertials/der Rotation?</li><li>Was habe ich insbesondere gelernt (theoretisch/praktisch)?</li><li>Wie erlebe ich mich in das Team integriert?</li><li>Wo habe ich persönlich noch Nachholbedarf? Was bringe ich selbst ein?</li><li>Was waren die Schwachstellen im bisherigen Verlauf des Tertials/derRotation?</li><li>Welche Teile des Logbuchs sind noch unbearbeitet? Welche Lernangebote brauche ich noch?</li></ul> <br>In <b>regelmäßigen Abständen (ca. alle 4 Wochen)</b> sollte zu einem festen Termin die ausgewählte punktuelle Beobachtung durch den/die PJ-Betreuer/in erfolgen. Für die Koordination des Termins übernimmt der/die PJ-Studierende die Verantwortung. Im Vorfeld spricht sich der/die PJ-Betreuer/in mit anderen an der Ausbildung beteiligten Personen ab."},{id:2 ,titel: "Abschlussgespräch", untertitel: "Wie war´s? Hat der/die PJ-Studierende die Ziele erreicht? Wie zufrieden sind sie?", inhalt:"Zum <b>Abschluss</b> des (Halb)-Tertials sollte jeder bzw. jede PJ Studierende die eigenen Entwicklungen der letzten 2 bzw. 4 Monate mit dem/der PJ Betreuerin in einem zusammenfassenden Gespräch analysieren.<br><br>Mit folgenden Fragen sollte der/die PJ Studierende sich auf das Gespräch vorbereiten:<ul><li>Was waren für mich die positiven Aspekte/Highlights des Tertials?</li><li>Was habe ich insbesondere gelernt (theoretisch/praktisch)?</li><li>Wie fühlte ich mich ins Team integriert?</li><li>Welche Ziele konnte ich nicht erreichen?</li><li>Was waren die Schwachstellen des Tertials?</li><li>Welche Verbesserungsvorschläge habe ich für die künftige Ausbildung?</li><li>Würde ich dieses Tertial bzw. diese Rotation weiter empfehlen/nochmals belegen?</li><li>Bin ich an einer Anstellung in diesem Arbeitsbereich interessiert?</li></ul><br>Neben einer erneuten Selbsteinschätzung der persönlichen Entwicklung und Erreichen der individuellen Ziele können auch Kritik und Verbesserungsvorschläge zu dem Ausbildungsabschnitt besprochen werden. <br><br>Der/die PJ-Betreuer/in gibt erneut ein strukturiertes Feedback zur persönlichen Entwicklung (Stärken, Verbesserungspotential, Ausblick). "}],
    aktivesGespraech: null,
    aktivesGespraechAnsicht: null,
    overlayGespraechsDokuAPT: false,
    vomNutzerimLogbuchGespeicherteGespraeche: [],
   
	
	
	
	steps: [
	{bezeichnung: "1", nr: 1, beschreibung:"Sie dürfen beobachten, aber APT am Patienten noch nicht anwenden", beschreibung1:"Sie dürfen beobachten, aber APT am Patienten noch nicht anwenden", beschreibung2:""},
	{bezeichnung: "2a", nr: 2, beschreibung:"Sie dürfen APT unter direkter Supervision (im Raum) durchführen und gemeinsam mit einer Ärztin/einem Arzt ausführen.",beschreibung1:"Sie dürfen APT unter direkter Supervision (im Raum) durchführen",beschreibung2:"und gemeinsam mit einer Ärztin/einem Arzt ausführen."},
	{bezeichnung: "2b", nr: 3, beschreibung:"Sie dürfen APT unter direkter Supervision (im Raum) durchführen und unter Beobachtung einer Ärztin/eines Arztes ausführen.",beschreibung1:"Sie dürfen APT unter direkter Supervision (im Raum) durchführen",beschreibung2:"und unter Beobachtung einer Ärztin/eines Arztes ausführen."},
	{bezeichnung: "3a", nr: 4, beschreibung:" Sie dürfen APT unter indirekter Supervision (Arzt/Ärztin auf Abruf) durchführen - eigenständig ausführen, wird umfassend nachgeprüft.", beschreibung1:" Sie dürfen APT unter indirekter Supervision (Arzt/Ärztin auf Abruf) durchführen", beschreibung2:"und eigenständig ausführen, wird umfassend nachgeprüft."},
	{bezeichnung: "3b", nr: 5, beschreibung:" Sie dürfen APT unter indirekter Supervision (Arzt/Ärztin auf Abruf) durchführen - eigenständig ausführen und Wichtiges wird nachgeprüft.",beschreibung1:" Sie dürfen APT unter indirekter Supervision (Arzt/Ärztin auf Abruf) durchführen",beschreibung2:" und eigenständig ausführen und Wichtiges wird nachgeprüft."},
	{bezeichnung: "3c", nr: 6, beschreibung:" Sie dürfen APT unter indirekter Supervision (Arzt/Ärztin auf Abruf) durchführen - eigenständig ausführen und Wichtiges wird durchgesprochen und ggf. punktuell nachgeprüft.",beschreibung1:" Sie dürfen APT unter indirekter Supervision (Arzt/Ärztin auf Abruf) durchführen und eigen",beschreibung2:"-ständig ausführen und Wichtiges wird durchgesprochen und ggf. punktuell nachgeprüft."}],


  };
};




export default new Vuex.Store({
  strict: true,
  namespaced: true,
  state: getDefaultState(),
    getters: {
    
    
    //PJ Spezifisch
    
    	getAktivesTertial: state => {return state.aktiverNutzer.rotation;},
		getAktivesTertialContent: state => {
		if (state.tertiale.filter(item => item.name ==  state.aktiverNutzer.rotation).length > 0) 
		{
		return state.tertiale.filter(item => item.name ==  state.aktiverNutzer.rotation)[0];}
		else
		{return null}
		},
		
		gettertiale: state => {return state.tertiale;},
		getTertialeNamen: state => {return state.tertiale.map(x => x.name);},
		getSteps: state => {return state.steps;},
		
		
		
		//APTs
		getAPTs: state => { return state.APTs.filter(item => item.tertial == state.aktiverNutzer.rotation);},
		getZeigeAPTmitID :  state => {return state.ZeigeAPTmitID;},
		getZeigeAPTmitIDObject :  state => {return state.APTs.filter(item => item.id == state.ZeigeAPTmitID)[0];},
		returnAPTFromAPTID : (state) => (APTID) => {
        let result = state.APTs.filter(item => item.id == APTID);
        if (result.length == 0) {
        return null}
        else
        {return result}
        },


		
		
		//GKs
		returnGKsforAPT: state => {return state.GKs.filter(item => item.in_apt == state.ZeigeAPTmitID);},
		returnAktiveGKObject: state => {return state.aktiveGK;},
		//returnAktiveGKID: state => {return state.aktiveGK.gk_id;},
		returnAktiveGKInhalte : state => {return state.GKInhalte.filter(item => item.gk_id == state.aktiveGK.gk_id);},

		
		
		//HKS
		returnHKsforAPT: state => {return state.HKs.filter(item => item.in_apt == state.ZeigeAPTmitID);},
		returnAktiveHKObject: state => {return state.aktiveHK;},
		//returnAktiveHKID: state => {return state.aktiveHK.gk_id;},
		returnAktiveHKInhalte: state => {return state.HKInhalte.filter(item => item.hk_id == state.aktiveHK.hk_id);},
		//returnDOPs : state => {return state.pruefungsstruktur.filter(item => item.hk_id == state.aktiveHK.hk_id);},




  
            
      wievieleDieserGKImLogbuch: (state) => (forGK) => {
        var anzahlImLogbuch = 0;
        if (state.vomNutzerimLogbuchGespeichertePruefungen.filter(item => item.gkhk == 1).length != 0) {
        anzahlImLogbuch =  (state.vomNutzerimLogbuchGespeichertePruefungen.filter(item => item.gkhk == 1).filter(item => item.pruefungsid == forGK).length) 
        }
        return anzahlImLogbuch;
        },
        
        
       dieseGKImLogbuch: (state) => (forGK) => {
        if (state.vomNutzerimLogbuchGespeichertePruefungen.filter(item => item.gkhk == 1).length != 0) {
        return (state.vomNutzerimLogbuchGespeichertePruefungen.filter(item => item.gkhk == 1).filter(item => item.pruefungsid == forGK)) 
        }
        return [];
        },
        
    wievieleDieserHKImLogbuch: (state) => (forHK) => {
        var anzahlImLogbuch = 0;
        if (state.vomNutzerimLogbuchGespeichertePruefungen.filter(item => item.gkhk == 2).length != 0) {
        anzahlImLogbuch =  (state.vomNutzerimLogbuchGespeichertePruefungen.filter(item => item.gkhk == 2).filter(item => item.pruefungsid == forHK).length) 
        }
        return anzahlImLogbuch;
        },
      
       dieseHKImLogbuch: (state) => (forHK) => {
        if (state.vomNutzerimLogbuchGespeichertePruefungen.filter(item => item.gkhk == 2).length != 0) {
        return (state.vomNutzerimLogbuchGespeichertePruefungen.filter(item => item.gkhk == 2).filter(item => item.pruefungsid == forHK)) 
        }
        return [];
        },
    
    
     GespraecheDieserArtImLogbuch: (state) => (forGespraechTitel) => {
        
        
        if (state.vomNutzerimLogbuchGespeicherteGespraeche.filter(item => item.art == forGespraechTitel).length != 0) {
        return (state.vomNutzerimLogbuchGespeicherteGespraeche.filter(item => item.art == forGespraechTitel)) 
        }
        return [];
        },
      
       
      
        
        getvomNutzerimLogbuchGespeichertePruefungen: state => { return state.vomNutzerimLogbuchGespeichertePruefungen;},
        getvomNutzerimLogbuchGespeicherteOffenePruefungen: state => { return state.vomNutzerimLogbuchGespeichertePruefungen.filter(item => item.erledigt == 0);},
        
        
        getvonAnwaerterinnenimLogbuchGespeichertePruefungen: state => { return state.vonAnwaerterinnenimLogbuchGespeichertePruefungen;},

		getadminList: state => { return state.adminList;},
		
		getAuthentifikation: state => { return state.authenfiziert;},
		getNutzer: state => { return state.aktiverNutzer;},
		geteditMode: state => {return (state.aktiverNutzer.editorrecht == 1) ? 1 : 0;},
		//getUser: state => {return state.user;},
		//getAPTs: state => { return state.epas.filter(item => item.Opa == 0);},
		//getOPAs: state => { return state.epas.filter(item => item.Opa == 1);},
		//getAPTsOPAs: state => { return state.epas;},
		//aktiveAPTID :  state => {return state.aktiveAPT;},
		//aktiveAPTIDObject :  state => {return state.epas[state.aktiveAPT-1];},
		
		getUnterschriftPendantListe: state => { return state.UnterschriftPendantListe;},
		
		getgespraeche: state => {return state.gespraeche;},
		getaktivesGespraech: state => {return state.aktivesGespraech;},
		getaktivesGespraechAnsicht: state => {return state.aktivesGespraechAnsicht;},
		getoverlayGespraechsDokuAPT: state => {return state.overlayGespraechsDokuAPT;},
		getvomNutzerimLogbuchGespeicherteGespraeche: state => {return state.vomNutzerimLogbuchGespeicherteGespraeche;},
		
		getAusstehendeUnterschriftenGespraeche: state => {return state.AusstehendeUnterschriftenGespraeche;},
		getAusstehendeUnterschriftenPruefungen: state => {return state.AusstehendeUnterschriftenPruefungen;},
		getAusstehendeUnterschriften: state => {return state.AusstehendeUnterschriftenGespraeche.length+state.AusstehendeUnterschriftenPruefungen.length;},


		
		
		// returnAPTIDObjectfromID : (state) => (idvar) => {return state.epas.filter(item => item.id == idvar)[0];},
// 
// 		
// 		returnAPTZugeordneteHK : state => { 
// 		var inepasundquerlinks = [];
// 		inepasundquerlinks.push(state.HKs.filter(item => item.in_apt == state.aktiveAPT));
// 		inepasundquerlinks.push(state.HKs.filter(item => (item.querlink_epa.split(",").includes(state.aktiveAPT))));
// 		return inepasundquerlinks;
// 		},
// 		
// 		returnAPTZugeordneteGK : state => {
// 		var inepasundquerlinks = [];
// 		inepasundquerlinks.push(state.gks.filter(item => item.in_apt == state.aktiveAPT));
// 		inepasundquerlinks.push(state.gks.filter(item => (item.querlink_epa.split(",").includes(state.aktiveAPT))));
// 		return inepasundquerlinks;
// 		},
// 		
// 		returnGKWithID: (state) => (gkid) => {
// 		var inepasundquerlinks = [];
// 		inepasundquerlinks.push(state.gks.filter(item => item.gk_id == gkid));
// 		return inepasundquerlinks;
// 		
// 		},
// 		
// 		
// 		returnAPTZugeordneteHKfunktion : (state) => (epaid) => {
// 		var inepasundquerlinks = [];
// 		inepasundquerlinks.push(state.HKs.filter(item => item.in_apt == epaid));
// 		inepasundquerlinks.push(state.HKs.filter(item => (item.querlink_epa.split(",").includes(epaid))));
// 		return inepasundquerlinks;
// 		
// 		},
// 		
// 		
// 		returnAPTZugeordneteGKfunktion : (state) => (epaid) => {
// 		var inepasundquerlinks = [];
// 		inepasundquerlinks.push(state.gks.filter(item => item.in_apt == epaid));
// 		inepasundquerlinks.push(state.gks.filter(item => (item.querlink_epa.split(",").includes(epaid))));
// 		return inepasundquerlinks;		},
// 		
		
		
		returnSucheGK : state => {
		return state.GKs
		.filter(item => (item.art.toLowerCase()+' # '+item.bezeichnung.toLowerCase()+item.beschreibung.toLowerCase()+item.titel.toLowerCase()).includes(state.searchString.toLowerCase()))
		;},
		returnSucheHK : state => {
		return state.HKs
		.filter(item => (item.art.toLowerCase()+' # '+item.bezeichnung.toLowerCase()+item.beschreibung.toLowerCase()+item.titel.toLowerCase()).includes(state.searchString.toLowerCase()))
		;},
		returnSucheGKItems: state => {
		return state.GKInhalte
		.filter(item => (item.frage.toLowerCase()+item.antwort.toLowerCase()).includes(state.searchString.toLowerCase()))
		;},

		getoverlayGKAddEditVisible: state => {return state.overlayGKAddEditVisible;},
		getoverlayEditPasswordVisible: state => {return state.overlayEditPasswordVisible;},
		getoverlayEditUserDetailsVisible: state => {return state.overlayEditUserDetailsVisible;},
		geteditUser: state => {return state.editUser;},
		geteditGK: state => {return state.editGK;},
		getoverlayHKAddEditVisible: state => {return state.overlayHKAddEditVisible;},
		geteditHK: state => {return state.editHK;},
		getoverlayInhalteGKAddEditVisible: state => {return state.overlayInhalteGKAddEditVisible;},
		getoverlayInhalteHKAddEditVisible: state => {return state.overlayInhalteHKAddEditVisible;},
		geteditInhalteGK: state => {return state.editInhalteGK;},
		geteditInhalteHK: state => {return state.editInhalteHK;},
		getbreadcrumbItems: state => {return state.breadcrumbItems;},
		getpathNewUploadedImage: state => {return state.pathNewUploadedImage;},


        getoverlayAPTEditVisible: state => {return state.overlayAPTEditVisible;},
        geteditAPT: state => {return state.editAPT;},


		getfilterwbjahr: state => {return state.filterwbjahr;},
	
		getausbilderUnterschrift: state => {return state.ausbilderUnterschrift;},
		getpopoverausbilderUnterschrift: state => {return state.popoverausbilderUnterschrift;},
		getdopslidervalues: state => {return state.dopslidervalues;},
		getkppvalues: state => {return state.kppvalues;},
        returnPruefungsnameFromPruefung : (state) => (pruefung) => {
        if (pruefung.gkhk == 2) {
        return state.HKs.filter(item => item.hk_id == pruefung.pruefungsid) 
        }
        return state.GKs.filter(item => item.gk_id == pruefung.pruefungsid) 
        },




     },
     
     
     
     
    mutations: {
    
    
    // PJ Sepzifisch
    
        setAktivesTertial(state, value) {state.aktiverNutzer.rotation = value.payload},
        
        setZeigeAPTmitID (state, value) {state.ZeigeAPTmitID = value.value},



        setBereiche(state, payload) {state.bereiche = payload.payload},
        setAPTs(state, payload) {state.APTs = payload.payload},
        setGKs (state, payload) {state.GKs = payload.payload},
        seteditGK (state, payload) {state.editGK = payload.payload},
        setHKs (state, payload) {state.HKs = payload.payload},
        setadminList(state, payload) {state.adminList = payload.payload},
        seteditHK (state, payload) {state.editHK = payload.payload},
        //setAktiveAPT (state, value) {state.aktiveAPT = value.value},
        setoverlayGKAddEditVisible (state, value) {state.overlayGKAddEditVisible = value.value},
        setoverlayHKAddEditVisible (state, value) {state.overlayHKAddEditVisible = value.value},
        setGKInhalte (state, payload) {state.GKInhalte = payload.payload;},
        setHKInhalte (state, payload) {state.HKInhalte = payload.payload;},
        seteditInhalteGK(state, payload) {state.editInhalteGK = payload.payload},
        seteditInhalteHK(state, payload) {state.editInhalteHK = payload.payload},
        
        setoverlayAPTEditVisible(state, value) {state.overlayAPTEditVisible = value.value},
        seteditAPT(state, payload) {state.editAPT = payload.payload},
        
        
         setAktivesGespraech(state, value) {state.aktivesGespraech = value.payload},
         setAktivesGespraechAnsicht(state, value) {state.aktivesGespraechAnsicht = value.payload},
        
        setoverlayInhalteGKAddEditVisible(state, value) {state.overlayInhalteGKAddEditVisible = value.value},
        setoverlayInhalteHKAddEditVisible(state, value) {state.overlayInhalteHKAddEditVisible = value.value},
        setoverlayEditUserDetailsVisible(state, value) {state.overlayEditUserDetailsVisible = value.value},
        setoverlayEditPasswordVisible(state, value) {state.overlayEditPasswordVisible = value.value},
        seteditUser(state, payload) {state.editUser = payload.payload},
        setfilterwbjahr(state, value) {state.filterwbjahr = value.value},
        setsearchString(state, value) {state.searchString = value},
        setUnterschriftPendantListe(state, value) {state.UnterschriftPendantListe = value}, //Um Autocomplete Nach vollen Namen filtern zu können
        setAktiverBereich(state, value) {state.aktiverBereich = value.value},
        setAuthentifikation(state, value) {state.authenfiziert = value.payload},
        setNutzer(state, value) {state.aktiverNutzer = value.payload},
        setvomNutzerimLogbuchGespeichertePruefungen(state, value) {state.vomNutzerimLogbuchGespeichertePruefungen = value.payload},
        setvomNutzerimLogbuchGespeicherteGespraeche(state, value) {state.vomNutzerimLogbuchGespeicherteGespraeche = value.payload},
        
        addvonAnwaerterinnenimLogbuchGespeichertePruefungen(state, value) {state.vonAnwaerterinnenimLogbuchGespeichertePruefungen.push(value.payload)},
        
        
         setausbilderUnterschrift(state, value) {state.ausbilderUnterschrift = value.payload},
         setpopoverausbilderUnterschrift(state, value) {state.popoverausbilderUnterschrift = value.payload},
         setAktiveGK(state, value) {state.aktiveGK = value.payload},
         setAktiveHK(state, value) {state.aktiveHK = value.payload},
         setdopslidervalues(state, value) {state.dopslidervalues = value.payload},
         setkppvalues(state, value) {state.kppvalues = value.payload},
         updatesliderdop(state, value) {state.dopslidervalues[value.i].val = value.val},
         updatekpp(state, value) {state.kppvalues[value.i].val = value.val},
         updateNewImageFilePath(state, value) {state.pathNewUploadedImage = value.value},
         setAusstehendeUnterschriftenGespraeche(state, value) {state.AusstehendeUnterschriftenGespraeche = value},
         setAusstehendeUnterschriftenPruefungen(state, value) {state.AusstehendeUnterschriftenPruefungen = value},


           
           
           
     
                  
        setbreadcrumbItems(state, payload) {
         if (Array.isArray(payload.payload)) {
            state.breadcrumbItems = payload.payload
           }
         else {
            state.breadcrumbItems = [payload.payload]
         }

         },
         
         addbreadcrumbItems(state, payload) { state.breadcrumbItems = state.breadcrumbItems.splice(0,payload.reduceTo).concat(payload.routeObject)},
         reducebreadcrumbItems(state, payload) { state.breadcrumbItems = state.breadcrumbItems.splice(0,payload.reduceTo)},
         
        
        
     },
     
     actions: {
     
      UpdateStoreFromAPI({ commit }) {
      
      
        axios.post(config.$api_url_inhalte, {
          
             funktion: "returnState",
           }, {
           headers: {
               'Content-Type': 'application/json'
        }})
        .then(function (response) {
        var stateObject = response.data;
        commit('setAPTs', { payload: stateObject.apts });
        commit('setGKs', { payload: stateObject.gks });
        commit('setHKs', { payload: stateObject.hks });
        commit('setGKInhalte', { payload: stateObject.contentGK });
        commit('setHKInhalte', { payload: stateObject.contentHK });


        })
        .catch(function (error) {
           console.log(error);
        });
        },
        
        
        UpdatePruefungenFromAPI({ commit }) {
       let vthis = this; //in Verschachtelten Funktionen vthis statt this! https://www.techalyst.com/posts/vuejs-this-is-undefined-error-in-javascript-array-filter-and-functions
            
        
        axios.post(config.$api_url_arbeitsdaten, {
             funktion: "getPruefungen",
             userid: vthis.state.aktiverNutzer.id
          },{
  headers: {
    'Content-Type': 'application/json'
  }
        })
        .then(function (response) {
        var stateObject = response.data;
        commit('setvomNutzerimLogbuchGespeichertePruefungen', { payload: stateObject.pruefungen });

        })
        .catch(function (error) {
           console.log(error);
        });
        
        
        },
        
        
         UpdatePruefungenFromAnwaerterMitIDFromAPI({ commit }, user) {
       let vthis = this; //in Verschachtelten Funktionen vthis statt this! https://www.techalyst.com/posts/vuejs-this-is-undefined-error-in-javascript-array-filter-and-functions
        
        axios.post(config.$api_url_arbeitsdaten, {
             funktion: "getPruefungen",
             userid: user.id
          },{
  headers: {
    'Content-Type': 'application/json'
  }
        })
        .then(function (response) {
        var stateObject = response.data;
        commit('addvonAnwaerterinnenimLogbuchGespeichertePruefungen', { payload: {userid : user.id, userfullname: user.fullname, pruefungen: stateObject.pruefungen }});

        })
        .catch(function (error) {
           console.log(error);
        });
        
        
        
        
        
        
        },
        
        
        UpdateGespraecheFromAPI({ commit }) {
       let vthis = this; //in Verschachtelten Funktionen vthis statt this! https://www.techalyst.com/posts/vuejs-this-is-undefined-error-in-javascript-array-filter-and-functions
            
        
        axios.post(config.$api_url_arbeitsdaten, {
             funktion: "getGespraeche",
             userid: vthis.state.aktiverNutzer.id
          },{
  headers: {
    'Content-Type': 'application/json'
  }
        })
        .then(function (response) {
        var stateObject = response.data;
        commit('setvomNutzerimLogbuchGespeicherteGespraeche', { payload: stateObject.gespraeche });

        })
        .catch(function (error) {
           console.log(error);
        });
        
        
        
        
        
        
        },
        
         UpdateUnterschriftPendantListeFromAPI({ commit }) {
       let vthis = this; //in Verschachtelten Funktionen vthis statt this! https://www.techalyst.com/posts/vuejs-this-is-undefined-error-in-javascript-array-filter-and-functions

        axios.post(config.$api_url_auth, {
             funktion: "getUnterschriftPendantListe",
             lehrort: "UKE",
             rolle: vthis.state.aktiverNutzer.rolle
        },{
  headers: {
    'Content-Type': 'application/json'
  }
})
        .then(function (response) {

        var stateObject = response.data;
		const updatedstateObject = stateObject.UnterschriftPendantListe.map((element) => ({
  		...element,
  		FullName: element.vorname + "_" + element.nachname
		}));        //Filtern auf Autrocomplete ermöglichen
  		
        commit('setUnterschriftPendantListe',  updatedstateObject );


        })
        .catch(function (error) {
           console.log(error);
        });
        
     return [];
    },
    

    
   returnAusstehendeUnterschrift({ commit }) {
 let vthis = this; //in Verschachtelten Funktionen vthis statt this! https://www.techalyst.com/posts/vuejs-this-is-undefined-error-in-javascript-array-filter-and-functions
axios.post(config.$api_url_arbeitsdaten, {
             funktion: "returnAusstehendeUnterschriftenSql",
             userid: vthis.state.aktiverNutzer.id,
         },{
  headers: {
    'Content-Type': 'application/json'
  }
        })
        
        .then(function (response) {
        var stateObject = response.data;
         commit('setAusstehendeUnterschriftenGespraeche',  stateObject.gespraeche);
         commit('setAusstehendeUnterschriftenPruefungen',  stateObject.pruefungen);


        })
        .catch(function (error) {
           console.log(error);

        });
      },
        
        
     UpdateAdminListFromAPI({ commit }) {
 let vthis = this; //in Verschachtelten Funktionen vthis statt this! https://www.techalyst.com/posts/vuejs-this-is-undefined-error-in-javascript-array-filter-and-functions
axios.post(config.$api_url_auth, {
            funktion: "adminList",
            user_mail: vthis.state.aktiverNutzer.email,
            user_lehrort: vthis.state.aktiverNutzer.lehrort,
            user_rolle: vthis.state.aktiverNutzer.rolle,


         },{
  headers: {
    'Content-Type': 'application/json'
  }
        })
        
        .then(function (response) {
        //vthis.adminListData = response.data.AdminList;
            var stateObject = response.data;
            commit('setadminList',{ payload: stateObject.AdminList })
        
        })
        .catch(function (error) {
           console.log(error);
        });
      
      
      
        
        return [];
     
     },

        },

})
